import React, { useState, useRef, useEffect } from 'react';
import { FaPlus, FaArchive, FaPen, FaBars, FaCog } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import "./style.css";
import { logout } from '../../reduser/userSlice';
import useIsMobile from '../../utils/useIsMobile';

function CustomNavbar() {
  const navigate = useNavigate();
  const username = useSelector(state => state.user.username);
  const dispatch = useDispatch();
  const isMobile = useIsMobile(768);
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleNavigation = (path) => {
    setActiveLink(path);
    navigate(path);
    setDropdownOpen(false);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const userRole = useSelector(state => state.user.role);
  const isSupervisor = useSelector(state => state.user.is_supervisor || false);
  const isAdmin = userRole === 'admin' || userRole === 'superuser';

  // Закрытие дропдауна при клике вне его
  useEffect(() => {
    if (!dropdownOpen) return;
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  const isActive = (path) => activeLink === path ? 'active' : '';

  return (
    <>
      {!isMobile ? (
        <nav className="nav-desktop">
          <div className="nav-links">
            <button
              className={`nav-link ${isActive('/note/new')}`}
              onClick={() => handleNavigation('/note/new')}
            >
              Новая
            </button>
            <button
              className={`nav-link ${isActive('/note/archive')}`}
              onClick={() => handleNavigation('/note/archive')}
            >
              Архив
            </button>
            <button
              className={`nav-link ${isActive('/note/sign_note')}`}
              onClick={() => handleNavigation('/note/sign_note')}
            >
              Подписать
            </button>

            {(isSupervisor || isAdmin) && (
              <div className="nav-dropdown-wrap" ref={dropdownRef}>
                <button
                  className="nav-dropdown-btn"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  Управление
                </button>
                {dropdownOpen && (
                  <div className="nav-dropdown-menu">
                    <button
                      className="nav-dropdown-item"
                      onClick={() => handleNavigation('/menu')}
                    >
                      Полное меню
                    </button>
                    <hr className="nav-dropdown-divider" />
                    <button
                      className="nav-dropdown-item"
                      onClick={() => handleNavigation('/activate_user')}
                    >
                      Активация пользователей
                    </button>
                    <button
                      className="nav-dropdown-item"
                      onClick={() => handleNavigation('/temporaryPasses')}
                    >
                      Создать пропуск
                    </button>
                    <button
                      className="nav-dropdown-item"
                      onClick={() => handleNavigation('/temporaryPassesList')}
                    >
                      Список пропусков
                    </button>
                  </div>
                )}
              </div>
            )}

            <button
              className={`nav-link ${isActive('/menu')}`}
              onClick={() => handleNavigation('/menu')}
            >
              Все разделы
            </button>
          </div>

          <div className="nav-right">
            {username ? (
              <>
                <span className="nav-username">{username}</span>
                {isAdmin && <span className="nav-badge nav-badge--admin">Админ</span>}
                {isSupervisor && <span className="nav-badge nav-badge--supervisor">Руководитель</span>}
                <button className="nav-logout" onClick={handleLogout}>
                  Выход
                </button>
              </>
            ) : (
              <>
                <button className="nav-link" onClick={() => navigate('/login')}>
                  Вход
                </button>
                <button className="nav-link" onClick={() => navigate('/register')}>
                  Регистрация
                </button>
              </>
            )}
          </div>
        </nav>
      ) : (
        <nav className="nav-mobile">
          <button
            className={`nav-mobile-link ${isActive('/note/new')}`}
            onClick={() => handleNavigation('/note/new')}
          >
            <FaPlus className="nav-mobile-icon" />
            <span className="nav-mobile-label">Новая</span>
          </button>
          <button
            className={`nav-mobile-link ${isActive('/note/archive')}`}
            onClick={() => handleNavigation('/note/archive')}
          >
            <FaArchive className="nav-mobile-icon" />
            <span className="nav-mobile-label">Архив</span>
          </button>
          <button
            className={`nav-mobile-link ${isActive('/note/sign_note')}`}
            onClick={() => handleNavigation('/note/sign_note')}
          >
            <FaPen className="nav-mobile-icon" />
            <span className="nav-mobile-label">Подписать</span>
          </button>
          <button
            className={`nav-mobile-link ${isActive('/menu')}`}
            onClick={() => handleNavigation('/menu')}
          >
            <FaBars className="nav-mobile-icon" />
            <span className="nav-mobile-label">Меню</span>
          </button>
        </nav>
      )}
    </>
  );
}

export default CustomNavbar;